import type { SelectionActions, SliceCreator } from './types';

const nextActiveBlock = (
  current: string | null,
  toolCallId: string,
  hasSelection: boolean
): string | null => {
  if (hasSelection) return toolCallId;
  if (current === toolCallId) return null;
  return current;
};

export const createSelectionSlice: SliceCreator<SelectionActions> = (set) => ({
  toggleBlockSelection: (toolCallId, id) =>
    set((s) => {
      const current = s.selectionByBlock[toolCallId] ?? [];
      const next = current.includes(id)
        ? current.filter((x) => x !== id)
        : [...current, id];
      return {
        selectionByBlock: { ...s.selectionByBlock, [toolCallId]: next },
        activeSelectionBlock: nextActiveBlock(
          s.activeSelectionBlock,
          toolCallId,
          next.length > 0
        ),
      };
    }),

  setBlockSelection: (toolCallId, ids) =>
    set((s) => ({
      selectionByBlock: { ...s.selectionByBlock, [toolCallId]: ids },
      activeSelectionBlock: nextActiveBlock(
        s.activeSelectionBlock,
        toolCallId,
        ids.length > 0
      ),
    })),

  clearBlockSelection: (toolCallId) =>
    set((s) => {
      const { [toolCallId]: _drop, ...rest } = s.selectionByBlock;
      return {
        selectionByBlock: rest,
        activeSelectionBlock: nextActiveBlock(
          s.activeSelectionBlock,
          toolCallId,
          false
        ),
      };
    }),
});
